import { render } from "./PracticeTestStudent.vue?vue&type=template&id=02f3db34&scoped=true"
import script from "./PracticeTestStudent.vue?vue&type=script&lang=js"
export * from "./PracticeTestStudent.vue?vue&type=script&lang=js"

import "./PracticeTestStudent.vue?vue&type=style&index=0&id=02f3db34&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f3db34"]])

export default __exports__